/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountAmount,
  DiscountAmountOptional,
  DiscountAmountMetaI,
  DiscountAmountTrackedI,
} from "./discount-amount";
import { DiscountAmountTracked, DiscountAmountMeta } from "./discount-amount";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";

/**
 *
 * @export
 * @interface ItemDiscountBase
 */
export interface ItemDiscountBaseOptional extends DiscountAmountOptional {
  /**
   *
   * @type {DiscountType}
   * @memberof ItemDiscountBase
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof ItemDiscountBase
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof ItemDiscountBase
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof ItemDiscountBase
   */
  requiresParentEligibility?: boolean;
}

export interface ItemDiscountBase
  extends ItemDiscountBaseOptional, DiscountAmount {
  /**
   *
   * @type {DiscountType}
   * @memberof ItemDiscountBase
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof ItemDiscountBase
   */
  amountCents?: number;
  /**
   *
   * @type {string}
   * @memberof ItemDiscountBase
   */
  percent?: string;
  /**
   *
   * @type {boolean}
   * @memberof ItemDiscountBase
   */
  requiresParentEligibility?: boolean;
}

export interface ItemDiscountBaseTrackedI extends DiscountAmountOptional {
  /**
   *
   * @type {DiscountType}
   * @memberof ItemDiscountBase
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ItemDiscountBase
   */
  amountCents?: number;
  amountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ItemDiscountBase
   */
  percent?: string;
  percentIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ItemDiscountBase
   */
  requiresParentEligibility?: boolean;
  requiresParentEligibilityIsSet: boolean;
}

transformDatesMap.set(
  "ItemDiscountBase",
  function (model: ItemDiscountBase) {},
);

export type ItemDiscountBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  amountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  percent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  requiresParentEligibility: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var ItemDiscountBaseMeta: ItemDiscountBaseMetaI =
  {} as ItemDiscountBaseMetaI;
ItemDiscountBaseMeta = typeMeta("ItemDiscountBase", {
  discountType: propertyMeta(
    "discountType",
    false,
    false,
    false,
    DiscountTypeMeta,
  ),
  amountCents: propertyMeta(
    "amountCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  percent: propertyMeta("percent", false, false, false, MetaTypesBase.string),
  requiresParentEligibility: propertyMeta(
    "requiresParentEligibility",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = ItemDiscountBaseMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DiscountAmountMeta]);
  metaI.discountType.inheritedFrom = DiscountAmountMeta.discountType;
  metaI.amountCents.inheritedFrom = DiscountAmountMeta.amountCents;
  metaI.percent.inheritedFrom = DiscountAmountMeta.percent;
});

export class ItemDiscountBaseTracked
  extends DiscountAmountTracked
  implements ItemDiscountBaseTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  amountCents__I?: number = undefined;
  amountCentsIsSet: boolean = false;
  set amountCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountCents__I = v;
      this.amountCentsIsSet = true;
    } else {
      this.amountCents__I = v || undefined;
      this.amountCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountCents() {
    return this.amountCents__I;
  }
  percent__I?: string = undefined;
  percentIsSet: boolean = false;
  set percent(v: undefined | string) {
    if (v !== undefined) {
      this.percent__I = v;
      this.percentIsSet = true;
    } else {
      this.percent__I = v || undefined;
      this.percentIsSet = false;
    }
    this.changeTracker = true;
  }
  get percent() {
    return this.percent__I;
  }
  requiresParentEligibility__I?: boolean = undefined;
  requiresParentEligibilityIsSet: boolean = false;
  set requiresParentEligibility(v: undefined | boolean) {
    if (v !== undefined) {
      this.requiresParentEligibility__I = v;
      this.requiresParentEligibilityIsSet = true;
    } else {
      this.requiresParentEligibility__I = v || undefined;
      this.requiresParentEligibilityIsSet = false;
    }
    this.changeTracker = true;
  }
  get requiresParentEligibility() {
    return this.requiresParentEligibility__I;
  }
  constructor(config?: ItemDiscountBaseOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: ItemDiscountBaseOptional,
    options?: AssignOptions,
  ): ItemDiscountBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.amountCents &&
      this.amountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountCents = config.amountCents;
      if (optionsRequired.unassign) this.amountCentsIsSet = false;
      else this.amountCentsIsSet = true;
    }
    if (config.percent && this.percentApplyFilter(optionsRequired.filter)) {
      this.percent = config.percent;
      if (optionsRequired.unassign) this.percentIsSet = false;
      else this.percentIsSet = true;
    }
    if (
      config.requiresParentEligibility &&
      this.requiresParentEligibilityApplyFilter(optionsRequired.filter)
    ) {
      this.requiresParentEligibility = config.requiresParentEligibility;
      if (optionsRequired.unassign) this.requiresParentEligibilityIsSet = false;
      else this.requiresParentEligibilityIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ItemDiscountBaseTrackedI {
    const cloned = {} as ItemDiscountBaseTrackedI;
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.amountCentsIsSetDeep() &&
      this.amountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountCentsIsSet = true;
      cloned.amountCents = this.amountCents;
    } else {
      //cloned.amountCentsIsSet = false
    }
    if (
      this.percentIsSetDeep() &&
      this.percentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.percentIsSet = true;
      cloned.percent = this.percent;
    } else {
      //cloned.percentIsSet = false
    }
    if (
      this.requiresParentEligibilityIsSetDeep() &&
      this.requiresParentEligibilityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.requiresParentEligibilityIsSet = true;
      cloned.requiresParentEligibility = this.requiresParentEligibility;
    } else {
      //cloned.requiresParentEligibilityIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ItemDiscountBaseTrackedI {
    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.amountCentsApplyFilter(filter)) this.amountCentsIsSet = false;

    if (!this.percentApplyFilter(filter)) this.percentIsSet = false;

    if (!this.requiresParentEligibilityApplyFilter(filter))
      this.requiresParentEligibilityIsSet = false;

    return this;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemDiscountBaseMeta.discountType,
      ItemDiscountBaseMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  amountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemDiscountBaseMeta.amountCents,
      ItemDiscountBaseMeta,
      this.amountCents,
      this,
    );
  }
  amountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountCentsIsSet && this.amountCentsApplyFilter(filter))
      return true;

    return false;
  }
  percentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemDiscountBaseMeta.percent,
      ItemDiscountBaseMeta,
      this.percent,
      this,
    );
  }
  percentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.percentIsSet && this.percentApplyFilter(filter)) return true;

    return false;
  }
  requiresParentEligibilityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ItemDiscountBaseMeta.requiresParentEligibility,
      ItemDiscountBaseMeta,
      this.requiresParentEligibility,
      this,
    );
  }
  requiresParentEligibilityIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.requiresParentEligibilityIsSet &&
      this.requiresParentEligibilityApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.amountCentsIsSetDeep(filter)) return true;
    if (this.percentIsSetDeep(filter)) return true;
    if (this.requiresParentEligibilityIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
